import React from 'react'
import {Provider} from 'react-redux'
import TopLevelState from './TopLevelState'
import {store} from './reducer'

export default function EntryPoint({props}) {
  return (
    <Provider store={store}>
      <TopLevelState {...props} />
    </Provider>
  )
}
